import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

const SingleFact = ({ message, value, dataCy }) => {
  return (
    value && (
      <React.Fragment>
        <div>
          <FormattedMessage {...message} />
        </div>
        <div data-cy={dataCy}>{value}</div>
      </React.Fragment>
    )
  );
};

SingleFact.propTypes = {
  message: PropTypes.object,
  value: PropTypes.string,
  dataCy: PropTypes.string,
};

export default injectIntl(SingleFact);
